export const actionTypes = {
  SET_COUNTRY_CODES: "ENTITIES:SET_COUNTRY_CODES",
};

export type phoneCodeType = {
  countryCode: string;
  name: string;
  id?: number;
};